<div>
    <br/>
    <br/>
    <div fxLayout="row" >
      <div fxLayout="column" fxFlex="5"></div>
      <div fxLayout="column" fxFlex="90" style="text-align:center" class="mat-headline-2 auto_margin"  fxLayoutAlign="center center">
        <b>{{ 'guest.client_platforms_heading'| translate }}</b>
      </div>
      <div fxLayout="column" fxFlex="5"></div>
    </div>

    <div fxLayout="row" >
      <div fxLayout="column" fxFlex="15"></div>
      <div fxLayout="column" fxFlex="70" class="mat-h2 auto_margin"  fxLayoutAlign="center center">
        {{ 'guest.client_platforms_description'| translate }}
      </div>
      <div fxLayout="column" fxFlex="15"></div>
    </div>

    <div fxLayout="row wrap" fxLayoutAlign="center">
      <div >
      <mat-card appearance="outlined" class="card-1 mat-card-custom" style="cursor: pointer;width:250px">
        <div fxLayout="row" fxLayoutAlign="center center" style="padding-bottom: 10px;">
            <div fxFlex="5" ></div>
            <div fxLayout="column" fxLayoutAlign="center center" fxFlex="10">
              <img  style="height: 50px;width: auto"  src="https://storage.googleapis.com/jivrus-web-images/jcp/box/google/google-logo.png"
                  class="" alt="" loading="eager" />
           </div>
            <div fxFlex="85"  class="mat-h2 auto_margin" fxLayoutAlign="center center">
                <b>Google Workspace</b>
            </div>
        </div>

        <div fxLayout="row" fxLayoutAlign="center center">
          {{ 'guest.google_workspace_description'| translate }}
        </div>
        <mat-divider class="divider"></mat-divider>

        <div fxLayout="row"  class="mat-h3 auto_margin" fxLayoutAlign="start"  style="margin-top: 5px;">
            <b> {{ 'guest.popular_client_integrations'| translate }} </b>
        </div>

        <div fxLayout="row" fxLayoutAlign="start">
            <div fxLayout="column" style="padding-bottom: 10px;">
                <div  fxLayoutAlign="start center"  style="padding-bottom: 10px;">
                    <mat-icon class="check-icon">check_circle</mat-icon> &nbsp; Google Looker Studio
                </div>
                <div  fxLayoutAlign="start center"  style="padding-bottom: 10px;">
                    <mat-icon class="check-icon">check_circle</mat-icon> &nbsp; Google Sheets
                </div>
                <div  fxLayoutAlign="start center" >
                    <mat-icon class="check-icon">check_circle</mat-icon> &nbsp; Google Forms
                </div>
            </div>
        </div>
        <div fxLayoutAlign="center center" fxLayout="row" >
            <a
               href="https://appiworks.jivrus.com/client-platforms/google" target="_blank"
               class="explore-button"
               mat-flat-button
             >{{ 'guest.explore_more'| translate }}
            </a>
        </div>

      </mat-card>

      <div fxLayout="column" fxHide fxShow.xs="true" fxShow.sm="true" style="height: 10px"></div>
      </div>

      <div fxLayout="column" fxHide.xs fxFlex="5"></div>

      <div>
      <mat-card  appearance="outlined"  class="card-1 mat-card-custom" style="cursor: pointer;width:250px">
        <div fxLayout="row" fxLayoutAlign="center center">
            <div fxFlex="5" ></div>
            <div fxFlex="10" style="padding-bottom: 10px;" fxLayout fxLayoutAlign="center center">
                <img style="height: 50px;width: auto"  src="https://storage.googleapis.com/jivrus-web-images/jcp/box/microsoft/microsoft-logo.png"
                  class="" alt="" loading="eager" />
           </div>
            <div  fxFlex="85"  class="mat-h2 auto_margin" fxLayoutAlign="center center">
                <b>Microsoft</b>
            </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="center center">
          {{ 'guest.microsoft_description'| translate }}
        </div>
        <mat-divider class="divider"></mat-divider>

        <div fxLayout="row"  class="mat-h3 auto_margin" fxLayoutAlign="start"  style="margin-top: 5px;">
            <b> {{ 'guest.popular_client_integrations'| translate }} </b>
        </div>

        <div fxLayout="row" fxLayoutAlign="start">
            <div fxLayout="column" style="padding-bottom: 10px;">
                <div  fxLayoutAlign="start center"  style="padding-bottom: 10px;">
                    <mat-icon class="check-icon">check_circle</mat-icon> &nbsp; Microsoft Excel
                </div>
            </div>
        </div>
        <div fxLayoutAlign="center center" fxLayout="row" style="margin-top:57px">
            <a
               href="https://appiworks.jivrus.com/client-platforms/microsoft" target="_blank"
              class="explore-button"
               mat-flat-button
             >{{ 'guest.explore_more'| translate }}
            </a>
        </div>

      </mat-card>

      <div fxLayout="column" fxHide fxShow.xs="true" fxShow.sm="true" style="height: 10px"></div>
      </div>
      <div fxLayout="column" fxHide.xs fxFlex="5"></div>
      <div>

      <mat-card  appearance="outlined"  class="card-1 mat-card-custom"  style="cursor: pointer;width:250px">
        <div fxLayout="row" fxLayoutAlign="center center">
            <div fxLayout="column" fxLayoutAlign="start" fxFlex="5"></div>
            <div fxLayout="column" fxLayoutAlign="center center" fxFlex="10"  style="padding-bottom: 10px;">
                <img style="height: 50px;width: auto"  src="https://storage.googleapis.com/jivrus-web-images/jcp/box/zoho/zoho-logo.png"
                  class="" alt="" loading="eager" />
           </div>
            <div fxFlex="85"  class="mat-h2 auto_margin" fxLayoutAlign="center center">
                <b>Zoho</b>
            </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="center center">
          {{ 'guest.zoho_description'| translate }}
        </div>
        <mat-divider class="divider"></mat-divider>

        <div fxLayout="row"  class="mat-h3 auto_margin" fxLayoutAlign="start"  style="margin-top: 5px;">
            <b> {{ 'guest.popular_client_integrations'| translate }} </b>
        </div>

        <div fxLayout="row" fxLayoutAlign="start">
            <div fxLayout="column" style="padding-bottom: 10px;">
                <div  fxLayoutAlign="start center"  style="padding-bottom: 10px;">
                    <mat-icon class="check-icon">check_circle</mat-icon> &nbsp; Zoho CRM
                </div>
                <div  fxLayoutAlign="start center"  style="padding-bottom: 10px;">
                    <mat-icon class="check-icon">check_circle</mat-icon> &nbsp; Zoho Books
                </div>
            </div>
        </div>

        <div fxLayoutAlign="center center" fxLayout="row" style="margin-top:25px">
            <a
               href="https://appiworks.jivrus.com/client-platforms/zoho" target="_blank"
               class="explore-button"
               mat-flat-button
             >{{ 'guest.explore_more'| translate }}
            </a>
        </div>
      </mat-card>
     </div>

    </div>

  <br/>
  <br/>
  <br/>
  </div>
